import type { TooltipProps as AntTooltipProps } from "antd";
import { Tooltip as AntdTooltip } from "antd";
import { addKeyIfNotUndefined } from "common/utils/universal/object";
import React from "react";

export type TooltipProps = AntTooltipProps & {
  dataTestId?: string;
  textColor?: string;
};
const Tooltip: React.FC<TooltipProps> = ({
  color,
  dataTestId,
  textColor,
  ...props
}) => {
  return (
    <AntdTooltip
      overlayInnerStyle={{
        color: textColor ? textColor : "black",
      }}
      {...addKeyIfNotUndefined("data-testid", dataTestId)}
      color={color ? color : "white"}
      {...props}
    />
  );
};

export default Tooltip;
